module.exports = __webpack_public_path__ + "images/banner-2.f89b41b2859ddae28b3acff855cb0734.jpg";